<script setup>
import AppButton from '#/general/AppButton'
import AppSwiper from '#/general/AppSwiper'
import { inject } from 'vue'
import B2CVideoSection from 'components/home/B2CVideoSection'
const { screen } = inject('Shared')

const steps = [
  {
    counter: 1,
    subtitle: ['Profitieren Sie', 'von unserer profunden Expertise'],
    text: 'Egal, welche Rahmen-bedingungen und Bedürfnisse Sie mit Ihrer Liegenschaft an uns herantragen, aufgrund unserer umfassenden Erfah-rung finden wir immer die bestmögliche Lösung.'
  },
  {
    counter: 2,
    subtitle: ['Lassen Sie sich unverbindlich beraten.'],
    text: 'Machen Sie von der Möglich-keit Gebrauch offene Fragen zum Entwicklungspotenzial Ihrer Liegenschaft persönlich mit uns zu besprechen, damit wir gemeinsam eine für Ihre Situation zugeschnittene Strategie finden können.'
  },
  {
    counter: 3,
    subtitle: ['Setzen Sie auf unser partner-schaftliches Modell.'],
    text: 'Uns liegt die Realisierung von Potenzialen am Herzen. Damit Sie nun das Potenzial Ihrer Liegenschaft ausschöpfen können, bieten wir Ihnen gerne kostenlose Vorleistungen an.'
  }
]
</script>

<template lang="pug">
.benefits--container
  .routerPageSize
    .benefits--content
      .benefits--subtitle Ihre Vorteile, wenn Sie mit uns starten:
      app-swiper.benefits--steps(:items="steps" :slides-per-view="screen.gt.sm ? 3 : 1.3" :loop="false" :space-between="screen.gt.sm ? 30 : 20")
        template(#item="props")
          .benefits--step
            .benefits--step-counter {{ props.item.counter }}
            .benefits--step-subtitle
              div(v-for="item in props.item.subtitle" :key="item") {{ item }}
            .benefits--step-text {{ props.item.text }}
      .benefits--submit-container
        app-button.benefits--submit(label="Jetzt Potenzial prüfen" @clicked="$emit('openAnalyzer')")
      .benefits--title
        div
          span Wir
          strong &#32; Raumpioniere &#32;
        div denken das Bauen neu.
      .benefits--text
        div Sie wollen das Potenzial Ihres Grundstücks bestmöglich ausschöpfen und gleichzeitig
        div all Ihren Bedürfnissen Rechnung tragen?
      b2-c-video-section
</template>

<style lang="sass">
.benefits--container
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  @media screen and (min-width: 1024px)
    padding-bottom: 135px
  .benefits--content
    display: flex
    flex-direction: column
    align-items: center
    position: relative
    color: #22223C
    @media screen and (min-width: 1024px)
      margin-top: 143px
    @media screen and (max-width: 1024px)
      margin-top: 39px
    .benefits--subtitle
      font-weight: 500
      line-height: 130%
      text-align: center
      color: #22223C
      @media screen and (min-width: 1024px)
        font-size: 34px
        margin-bottom: 100px
      @media screen and (max-width: 1024px)
        font-size: 24px
        margin-bottom: 32px
    .benefits--steps
      .swiper-slide
        padding-top: 50px !important
      .benefits--step
        padding: 30px
        position: relative
        width: calc(100% - 60px)
        background: #F6F7FA
        backdrop-filter: blur(5px)
        border-radius: 10px
        height: 100%
        @media screen and (min-width: 1024px)
          max-width: calc(100% - 60px)
          margin-bottom: 4px
          height: 507px
        @media screen and (max-width: 1024px)
          margin-bottom: 38px
          max-width: calc(100% - 20px)
        .benefits--step-counter
          position: absolute
          display: flex
          flex-direction: row
          justify-content: center
          align-items: center
          background: #1F47CD
          border-radius: 100%
          font-weight: 500
          color: white
          @media screen and (min-width: 1024px)
            width: 100px
            height: 100px
            max-width: 100px
            max-height: 100px
            top: -50px
            left: calc(50% - 50px)
            font-size: 50px
            line-height: 30px
          @media screen and (max-width: 1024px)
            width: 75px
            height: 75px
            max-width: 75px
            max-height: 75px
            top: -37.5px
            left: calc(50% - 37.5px)
            font-size: 40px
            line-height: 30px
        .benefits--step-subtitle
          margin-top: 70px
          font-weight: 500
          line-height: 125%
          background: linear-gradient(152.99deg, #2F3849 24.83%, #21252E 103.84%)
          -webkit-background-clip: text
          -webkit-text-fill-color: transparent
          text-fill-color: transparent
          margin-bottom: 18px
          @media screen and (min-width: 1024px)
            font-size: 34px
          @media screen and (max-width: 1024px)
            font-size: 24px
        .benefits--step-text
          line-height: 150%
          color: #22223C
          margin-bottom: 18px
          @media screen and (min-width: 1024px)
            font-size: 20px
          @media screen and (max-width: 1024px)
            font-size: 16px
    .benefits--submit-container
      width: 100%
      display: flex
      justify-content: center
      .benefits--submit
        background: #1F47CD
        border-radius: 10px
        padding: 0 46px
        @media screen and (min-width: 1024px)
          margin-top: 48px
          margin-bottom: 150px
          font-size: 20px !important
        @media screen and (max-width: 1024px)
          margin: 0px 0 78px
          font-size: 16px !important
    .benefits--title
      font-weight: 500
      line-height: 130%
      text-align: center
      @media screen and (min-width: 1024px)
        margin-bottom: 65px
        font-size: 55px
      @media screen and (max-width: 1024px)
        margin-bottom: 35px
        font-size: 30px
    .benefits--text
      line-height: 150%
      text-align: center
      @media screen and (min-width: 1024px)
        font-size: 20px
        margin-bottom: 100px
      @media screen and (max-width: 1024px)
        font-size: 16px
        margin-bottom: 48px
</style>
